import ApplicationController from './application_controller';

export default class extends ApplicationController {
  toggle() {
    const navMenu = document.getElementById('nav-menu');
    navMenu.classList.toggle('hidden');

    document.body.classList.toggle('overflow-hidden');
  }
}
